import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { addYears, subYears } from 'date-fns';
import { QueryService } from '@app/core/graphql/query/query.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { MutationService } from '@app/core/graphql/mutation/mutation.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
    selector: 'app-user-passport-information',
    templateUrl: './user-passport-information.component.html',
    styleUrls: ['./user-passport-information.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, MatDatepickerModule, MatNativeDateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class UserPassportInformationComponent implements OnInit {
    // @Input() content: any;
    // @Input() profileForm: FormGroup;

    maxIssueDate = addYears(new Date(), 18);
    maxExpirationDate = addYears(new Date(), 18);
    minDate = subYears(new Date(), 18);

    constructor(
        private queryService: QueryService,
        private formBuilder: FormBuilder,
        private toolService: ToolService,
        private mutationService: MutationService,
        private toastService: ToastService
    ) {}

    travelForm: FormGroup = this.formBuilder.group({
        passportnumber: new FormControl(''),
        passportissuecountry: new FormControl(''),
        passportissuedate: new FormControl(''),
        passportexpiredate: new FormControl(''),
    });

    content: any;

    ngOnInit() {
        // get user latest travel requirements data
        this.queryService
            .profileTravelRequirements()
            .subscribe((response: any) => {
                this.travelForm.patchValue(response.data.user);
            });
        // get content
        this.toolService.content.subscribe(
            (content: any) => (this.content = content)
        );
    }

    trackByIndex = (index: number): number => index;

    submit() {
        const data = this.travelForm.value;
        this.mutationService
            .updateProfileTravelReqs(data)
            .subscribe((response: any) => {
                if (response.data.updateProfileTravelReqs.success) {
                    this.toastService
                        .successToast()
                        .then()
                        .catch();
                }
            });
    }
}
